import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { OmitStylesComponentProps } from '../../types';
import { cva, VariantProps } from 'class-variance-authority';

const radioGroupVariants = cva('rocco-radio-group grid', {
    variants: {
        variant: {
            default: '',
        },
        gap: {
            default: 'gap-y-1',
            none: '',
        },
    },
    defaultVariants: {
        variant: 'default',
        gap: 'default',
    },
});

export const RadioGroup = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    OmitStylesComponentProps<typeof RadioGroupPrimitive.Root> &
        VariantProps<typeof radioGroupVariants>
>(({ variant, gap, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Root
            className={radioGroupVariants({ variant, gap })}
            {...props}
            ref={ref}
        />
    );
});

RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
